import { render, staticRenderFns } from "./GroupSelection.vue?vue&type=template&id=9080b98c&scoped=true"
import script from "./GroupSelection.vue?vue&type=script&lang=js"
export * from "./GroupSelection.vue?vue&type=script&lang=js"
import style0 from "./GroupSelection.vue?vue&type=style&index=0&id=9080b98c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9080b98c",
  null
  
)

export default component.exports